// extracted by css-extract-rspack-plugin
export default {"CommentsNew":"CommentsNew-mIjdI9","commentsNew":"CommentsNew-mIjdI9"};